export default __webpack_public_path__ + "static/media/ren_46.5ea76f35.png";